import type { Direction } from "../../../engine/direction";
import { BurstParticle } from "./burstParticle";

export class BlueBloodParticle extends BurstParticle {
	constructor(originX: number, originY: number, direction?: Direction) {
		super(
			originX,
			originY,
			{
				ttl: [250, 600],
				size: [0.35, 0.25],
				color: { r: 30, g: 60, b: 180 },
				speed: [2, 4],
				gravity: 3.0,
			},
			direction,
		);
	}
}
